module.exports = __webpack_public_path__ + "media/images/flags/4x3/swz-af91e9da095760f97eada1f4c6188b33.svg";